<template>
  <!-- 人数分布图 -->
  <div class="line-echarts">
    <div class="tip">{{ line.title }}</div>
    <div class="inner">
      <div class="title">
        <div class="left">油气集团</div>
        <div class="right">
          排名 {{ line.ranking }} ，百分比排名 {{ line.range * 100 }}%
        </div>
        <div class="mapTitle">{{ line.mapTitle }}</div>
      </div>
      <div class="canvas-box" ref="myChart"></div>
    </div>

    <div v-if="line.showTab" class="tab-tip">
      <span class="location"></span> <span>您的位置</span>
      <span class="color-box" v-for="(color, index) in line.colors" :key="index"
        ><span class="color" :style="{ background: color.color }"></span>
        <span v-text="color.name"></span>
      </span>
    </div>
  </div>
</template>

<script>
import { line } from "./config";
export default {
  props: ["model"],
  data() {
    return {
      line: line,
    };
  },
  mounted() {
    if (this.model) {
      this.line = this.model;
    }
    this.renderMap();
  },
  methods: {
    renderMap() {
      let myChart = (window.cc = this.$echarts.init(this.$refs.myChart));
      let score = this.line.score;
      let renshu = this.line.renshu;
      let markLineStyle = {
        cap: "butt",
      };
      let xAxisShow = {
        color: "#333",
      };
      let xAxisHide = {
        color: "#fff",
      };
      let scoreIndex = 0;
      let left_value = 0;
      let right_value = 0;
      if (score > 0 && score <= 1) {
        (left_value = renshu[0]), (right_value = renshu[1]);
      }
      if (score > 1 && score <= 2) {
        (left_value = renshu[1]), (right_value = renshu[2]);
      }
      if (score > 2 && score <= 3) {
        (left_value = renshu[2]), (right_value = renshu[3]);
      }
      if (score > 3 && score <= 3.5) {
        (left_value = renshu[3]), (right_value = renshu[4]);
      }
      if (score > 3.5 && score <= 4) {
        (left_value = renshu[4]), (right_value = renshu[5]);
      }
      if (score > 4 && score < 5) {
        (left_value = renshu[5]), (right_value = renshu[6]);
      }
      if (score == 5) {
        (left_value = renshu[6]), (right_value = renshu[6]);
      }
      let nowRen =
        left_value[1] +
        parseInt((right_value[1] - left_value[1]) * (score - parseInt(score)));
      let option = {
        xAxis: {
          name: "分数",
          nameLocation: "start",
          type: "value",
          nameTextStyle: {
            fontWeight: "bolder",
          },
          boundaryGap: false,
          splitNumber: 5,
          splitLine: {
            show: false,
          },
          min: 0,
          max: 5,
        },
        yAxis: [
          {
            show: false,
          },
          {
            name: "人数",
            type: "value",
            nameTextStyle: {
              fontWeight: "bolder",
            },
            splitNumber: 1,
            axisLine: {
              show: true,
            },
            splitLine: {
              show: false,
            },
            position: "right",
          },
        ],
        visualMap: {
          show: false,
          dimension: 0,
          pieces: [
            {
              lte: 2,
              color: this.line.colors[0].color,
            },
            {
              gt: 2,
              lte: 3,
              color: this.line.colors[1].color,
            },
            {
              gt: 3,
              lte: 3.5,
              color: this.line.colors[2].color,
            },
            {
              gt: 3.5,
              lte: 4,
              color: this.line.colors[3].color,
            },
            {
              gt: 4,
              color: this.line.colors[4].color,
            },
          ],
        },
        series: [
          {
            name: "得分",
            type: "line",
            smooth: true,
            data: this.line.renshu, //renshu
            yAxisIndex: 1,
            markPoint: {
              symbol: "circle",
              symbolSize: 15,
              symbolOffset: [10, 10],
              itemStyle: {
                color: "#244061",
              },
              data: [
                {
                  value: "(" + score + " 分，高于 " + this.line.higher + " 人)",
                  label: {
                    show: true,
                    color: "#333",
                    fontWeight: "bold",
                    fontSize: 16,
                    position: "top",
                  },
                  coord: [score, nowRen],
                },
              ],
            },
            markLine: {
              silent: true,
              data: [
                [
                  {
                    coord: [5, nowRen],
                    symbolSize: 0,
                  },
                  {
                    coord: [score, nowRen],
                    symbolSize: 0,
                  },
                ],
                [
                  {
                    coord: [score, 0],
                    symbolSize: 0,
                  },
                  {
                    coord: [score, nowRen],
                    symbolSize: 0,
                  },
                ],
              ],
            },
          },
        ],
      };
      myChart.setOption(option);
    },
  },
};
</script>

<style lang="scss" scoped>
.line-echarts {
  .tip {
    padding: 6px 0px;
  }
  .inner {
    border: 2px solid #10253f;
    font-family: Arial, sans-serif;
  }
  .title {
    background: #10253f;
    color: #fff;
    padding: 10px;
    display: inline-block;
    clear: both;
    position: relative;
    width: 100%;
    .left {
      float: left;
    }
    .right {
      float: right;
    }
    .mapTitle {
      position: absolute;
      top: 50px;
      width: 100%;
      color: #333;
      text-align: center;
    }
  }
  .canvas-box {
    width: 600px;
    height: 350px;
    margin: 10px auto 0px;
  }
  .tab-tip {
    display: flex;
    margin-top: 10px;
    span {
      margin-right: 8px;
    }
    .location {
      width: 15px;
      height: 15px;
      border-radius: 15px;
      background: #244061;
      display: block;
    }
    .color-box {
      display: flex;
      margin-left: 10px;
      .color {
        width: 30px;
        height: 8px;
        margin-top: 5px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/dataView/echarts/line.vue